import React, { useEffect, useState, forwardRef } from 'react';
import './Components.css';
import { Cross2Icon } from '../icons/Icons';

const PostShotModal = forwardRef(({ header, children, modalState, buttonLabel = "Okay", usesTimer = false, timerSeconds = 5 }, ref) => {

    const [secondsLeft, setSecondsLeft] = useState(timerSeconds);

    const closeModal = () => {
        modalState(false);
    }

    useEffect(() => {
        if (!usesTimer) return;
        setSecondsLeft(timerSeconds);
    }, [usesTimer, timerSeconds]);

    // Countdown + auto-close
    useEffect(() => {
        if (!usesTimer) return;

        // If we've reached zero, close
        if (secondsLeft <= 0) {
            closeModal();
            return;
        }

        const id = setInterval(() => {
            setSecondsLeft((s) => s - 1);
        }, 1000);

        return () => clearInterval(id);
    }, [usesTimer, secondsLeft]); // intentionally depends on secondsLeft

    useEffect(() => {
        const onKeyDown = (e) => {
            if (e.key === "Enter") {
                e.preventDefault();
                closeModal();
            }
        };

        window.addEventListener("keydown", onKeyDown);
        return () => window.removeEventListener("keydown", onKeyDown);
    }, []); // runs while modal is mounted


    return (
        <div className='modal-container' style={{ height: "300px", maxWidth: "450px" }}>
            <button className='modal-close-button' onClick={() => modalState(false)}><Cross2Icon width='30px' height='30px' /></button>
            <div className='modal-header'>{header}</div>
            <div className='modal-content'>
                {children}
                {usesTimer && (
                    <div style={{ marginTop: "10px", opacity: 0.8 }}>
                        Closing in {secondsLeft}s...
                    </div>
                )}
            </div>
            <div className="modal-footer" >
                <button className="button" style={{ width: '100px' }} onClick={() => closeModal()}>{buttonLabel}</button>
            </div>
        </div>
    );
});

export default PostShotModal;